import { SET_QUICK_VIEW } from '../constants/QuickViewConstants';

// Get initial isQuickView value from localStorage if available
const getSavedQuickViewState = (): boolean => {
  try {
    const savedState = localStorage.getItem('isQuickView');
    return savedState === 'true';
  } catch (e) {
    return false;
  }
};

const initialState = {
  isQuickView: getSavedQuickViewState(),
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case SET_QUICK_VIEW:
      try {
        localStorage.setItem('isQuickView', String(action.payload));
      } catch (e) {
        console.error('Failed to save quick quote state to localStorage:', e);
      }
      return {
        ...state,
        isQuickView: action.payload,
      };
    default:
      return state;
  }
};
